import * as React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import HideRevealToggleButton from '../../components/HideRevealToggleButton'
import { useDebounce } from 'use-debounce'
import Popper from '@mui/material/Popper'
import { Link } from 'gatsby'
import NavItemWrapper from './NavItemWrapper'
import UseCasesMenu from './UseCasesMenu'
import { useState } from 'react'

const UseCasesDropDownMenu = () => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const [isOpen, setIsOpen] = useState(false)
    const [openDebounced] = useDebounce(isOpen, 100)

    const handleHover = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
        setIsOpen(true)
    }

    const handleClose = () => {
        setIsOpen(false)
    }

    return (
        <>
            <Link
                to={``}
                style={{
                    textDecoration: 'none',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                    lineHeight: 0,
                    color: `#212121`,
                }}
                onClick={(e) => e.preventDefault()}
            >
                <NavItemWrapper
                    onMouseOver={handleHover}
                    onMouseLeave={handleClose}
                    id={'basic-menu'}
                    isOpen={isOpen}
                >
                    <div
                        style={{
                            textDecoration: 'none',
                            textAlign: 'left',
                            whiteSpace: 'nowrap',
                            marginRight: `-6px`,
                        }}
                    >
                        <Typography variant={`button`} color={`Gray900`}>
                            Use Cases
                        </Typography>
                        <HideRevealToggleButton isOpen={openDebounced} />
                    </div>
                </NavItemWrapper>
            </Link>
            <Popper
                id="basic-menu"
                anchorEl={anchorEl}
                open={true}
                onClick={handleClose}
                onMouseOver={() => setIsOpen(true)}
                onMouseLeave={handleClose}
                keepMounted
                style={{
                    zIndex: isOpen ? '9999' : '0',
                    transition: 'zIndex .3s cubic-bezier(0.4, 0, 1, 1)',
                    pointerEvents: isOpen ? 'all' : 'none',
                }}
            >
                <Box
                    className={`${openDebounced ? 'menuOpened' : ''}`}
                    sx={{
                        transition: 'all .3s cubic-bezier(0.4, 0, 1, 1)',
                        animation: 'show .3s cubic-bezier(0.4, 0, 1, 1)',
                        mt: 2,
                        opacity: 0,
                        zIndex: -1,
                        '&.menuOpened': {
                            mt: 3,
                            opacity: 1,
                            zIndex: 999,
                        },
                    }}
                >
                    <Box
                        sx={{
                            borderRadius: `16px`,
                            padding: 0,
                            backgroundColor: `White`,
                            boxShadow: 16,
                        }}
                    >
                        <UseCasesMenu />
                    </Box>
                </Box>
            </Popper>
        </>
    )
}

export default UseCasesDropDownMenu
